import m from 'mithril'
import { home, question } from '../lib/icons'


export default {
  view(vnode) {
    var {user, client, scope} = vnode.attrs

    var scopeList = scope.split(' ').filter(x=>x)

    return m('.access-dialog',

      m('.text-center.mb-2',

        m('.flex-centered',
          m('figure.avatar.avatar-xl.avatar-svg', home),

          m('div', {
            style: `
              width: 6rem;
              border-top: 2px dashed hsla(256, 60%, 82%, 1);
              align-self: center;
              line-height: 0;
            `
          },
            m('span.bg-gray.p-1', { style: `border: 1px solid #ccc;` }, "Allow?")
          ),

          client.meta.avatar
            ? m('figure.img-xl', m('img', { src: client.meta.avatar }))
            : m('figure.avatar.avatar-xl.avatar-svg', question)
        ),

        m('h1.h3', { style: `margin: 1.5rem` }, "Installation Request"),
      ),

      m('.body-content.padding.mw-sm.centered.text-center',
        m('.text-large.py-2',
          client.meta.name ? m('b', client.meta.name) : m('b', 'An ', m('i', 'anonymous app'))
        ),
        m('p',
          "...is requesting privilege to store data in your BYOD Home.",
          m('br'),
        ),

        scopeList.length
        ? [
          m('p', "It wishes to:"),

          m('.text-left.text-margin.pb-2.d-inline-flex.flex-col.flex-justify-center',
            scopeList.concat(scopeList,['gist.github.network']).map( scope =>
              m(prettyScope, { client: client, scope: scope })
            )
          ),

          m('button.btn.btn-success.btn-block.mb-2', "Authorize " + client.host),

          m('small.p-2', "Authorizing will redirect back to their website."),
        ] : [
          m('p', m('b', 'However, '), `it did not ask for any specific permissions,
                  and therefore cannot be granted any permissions.`),
          m('p', `This their fault, not yours. If you want to use this Bapp,
                  I suggest you contact them about this bug.`),

          m('button.btn.m-1', {
            onclick: () => window.location.replace(client.redirect_uri)
          }, "< Back to their website"),
          m('button.btn.m-1', {
            onclick: () => window.location.replace('/admin')
          }, "Manage My Stuff >"),
        ],

      )
    )
  }
}

const prettyScope = {
  oninit(vnode) {
    vnode.state.open = false
  },
  toggle() {
    this.open = ! this.open
  },
  view(vnode) {
    var {client, scope} = vnode.attrs

    var label, icon, isForeign

    if ( scope === client.host ) {
      isForeign = false
      icon = "👍"
      label = "Read & Write its own data"
    }
    else {
      isForeign = true
      icon = "🤔"
      label = ["Read & Write ", m('b',scope), " bapp data"]
    }
    // TODO: Handle read-only and write-only scopes

    return m('.tile.bg-gray.mb-1.p-2',
      { style: `border: 1px solid #ccc; flex: 1 0 auto` },
      m('.tile-icon', icon),
      m('.tile-content.flex',
        m('.tile-title', label),
        m('.tile-subtitle.text-gray', scope),
        vnode.state.open && m('div', "stuff")
      ),

      isForeign &&
        m('.tile-action',
          m('button.btn.btn-sm', {
            style: `width: 3.75rem;`,
            onclick: () => vnode.state.toggle()
          }, vnode.state.open ? "Close" : "View Info")
        )
    )
  }
}
